import React from "react";
import { SharedValues } from "../Tools/SharedValues";
import _ from "lodash";

interface IProps {
  message: string;
  replacements: MessageReplacement[];
}

class MessageReplacement {
  key: string;
  replacement: string;
  bold?: boolean;
}

export class MessageWithReplacements extends React.Component<IProps> {
  getMessageParts(): string[] {
    var template = SharedValues.getLocalizationValue(this.props.message);
    return _.split(template, /\{|\}/ig);
  }

  render() {    
    return (
      <>
        {this.getMessageParts().map(part => {
          var replacement = _.find(this.props.replacements, x => x.key === part);
          if (_.isNil(replacement)) {
            return part;
          }
          return replacement.bold ? <b>{replacement.replacement}</b> : replacement.replacement;
        })}
      </>       
    );
  }
}
